import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BeanProfile } from '../../../../bean/BeanProfile';

@Injectable()

export class ProfileService {

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders(){

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public listarProfiles():Promise<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.listarProfiles}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  public getProfile(idProfile:string):Promise<any>{

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.getProfile}${idProfile}`, {headers})
    .toPromise()
    .then((resposta:any) => resposta);
  }

  addProfile(formModel: BeanProfile):Promise<any>{
    return this.gravarProfile(formModel).toPromise().then((resposta:any) => resposta);
  }

  public gravarProfile(formModel: BeanProfile):Observable<any>{

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.post(`${environment.urlBackend}${environment.criarProfile}`,json, {headers});
  }

  updateProfile(formModel: BeanProfile):Promise<any>{
    return this.atualizarProfile(formModel).toPromise().then((resposta:any) => resposta);
  }

  public atualizarProfile(formModel: BeanProfile):Observable<any> {

    const headers = this.getHeaders();

    let json = JSON.stringify(formModel);

    return this.http.put(`${environment.urlBackend}${environment.updateProfile}${formModel.perfIdCdPerfil}`, json, {headers});
  }
}
